import type { BereichDefinition } from './bereiche'

const PRAEFIX = 'famora.navigation.pins.'
export const MAX_PINS = 3
export const NAVIGATION_GEAENDERT = 'famora-navigation-geaendert'

const speicher = (): Storage | null => (typeof window === 'undefined' ? null : window.localStorage)

export function standardPins(bereiche: readonly BereichDefinition[]): string[] {
  return bereiche
    .filter((bereich) => !['heute', 'einstellungen'].includes(bereich.id))
    .slice(0, MAX_PINS)
    .map((bereich) => bereich.id)
}

export function ladePins(memberId: string, bereiche: readonly BereichDefinition[]): string[] {
  const roh = speicher()?.getItem(`${PRAEFIX}${memberId}`)
  if (!roh) return standardPins(bereiche)
  try {
    const ids = JSON.parse(roh) as unknown
    return Array.isArray(ids)
      ? [...new Set(ids.filter((id): id is string => typeof id === 'string'))].slice(0, MAX_PINS)
      : standardPins(bereiche)
  } catch {
    return standardPins(bereiche)
  }
}

export function speicherePins(memberId: string, ids: readonly string[]): void {
  const naechste = [...new Set(ids)].slice(0, MAX_PINS)
  speicher()?.setItem(`${PRAEFIX}${memberId}`, JSON.stringify(naechste))
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(NAVIGATION_GEAENDERT))
}
